export enum EmployeeStatus {
  Disabled = 0,
  Applicant = 1,
  OnBoarding = 2,
  FullTime = 3,
  PartTime = 4,
  OffBoarding = 5,
  LeaveOfAbsence = 6,

  //Other Options
  Active = 100
}

export const EmployeeStatusMapping: Record<EmployeeStatus, string> = {
  [EmployeeStatus.Disabled]: 'Disabled',
  [EmployeeStatus.Applicant]: 'Applicant',
  [EmployeeStatus.OnBoarding]: 'On Boarding',
  [EmployeeStatus.FullTime]: 'Full Time',
  [EmployeeStatus.PartTime]: 'Part Time',
  [EmployeeStatus.OffBoarding]: 'Off Boarding',
  [EmployeeStatus.LeaveOfAbsence]: 'Leave of Absence',
  [EmployeeStatus.Active]: 'Active'
};

export const EmployeeStatusSelectable: EmployeeStatus[] = [
  EmployeeStatus.Applicant,
  EmployeeStatus.FullTime,
  EmployeeStatus.PartTime,
  EmployeeStatus.LeaveOfAbsence,
  EmployeeStatus.Disabled
];

